module.exports = __webpack_public_path__ + "img/2.882ef802.jpg";